import WsProvider from './provider/WSProvider'


var serviceName = "webservis";
var moduleName = "tatil";


var tatilService = {
    imagePath: WsProvider.imagePath,
    imagePathBuyuk: WsProvider.imagePathBuyuk,
    imagePathOrta: WsProvider.imagePathOrta,
    imagePathKucuk: WsProvider.imagePathKucuk,
    belgePath: WsProvider.documentPath,
    path: WsProvider.path,
    currentMounthHoliday() {
        var userDataDemirag = localStorage.getItem("userDataDemirag");
        var param = {
            token: userDataDemirag,
            serviceName: 'resmitatil',
            methodName: "resmiTatilVarmi"
        }
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
        return result
    },
    resmiTatilListele(baslangic, limit, yil) {
        var userDataDemirag = localStorage.getItem("userDataDemirag");
        var param = {
            token: userDataDemirag,
            baslangic: baslangic,
            limit: limit,
            yil: yil,
            serviceName: moduleName,
            methodName: "listele"
        }
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
        return result
    },
    resmiTatilDetay(resmiTatilID) {
        var userDataDemirag = localStorage.getItem("userDataDemirag");
        var param = {
            token: userDataDemirag,
            resmiTatilID,
            serviceName: moduleName,
            methodName: "detay"
        }
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
        return result
    },
    resmiTatilEkle(baslamaTarihi, bitisTarihi, sebep, tamGun, gunMiktari) {
        var userDataDemirag = localStorage.getItem("userDataDemirag")
        var param = {
            token: userDataDemirag,
            baslamaTarihi: baslamaTarihi,
            bitisTarihi: bitisTarihi,
            sebep: sebep,
            tamGun: tamGun,
            gunMiktari: gunMiktari,
            methodName: "ekle",
            serviceName: moduleName
        }

        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        });
        return result;
    },
    resmiTatilFiltrele(baslamaTarihi, bitisTarihi, sebep, tamGun, gunMiktari, baslangic, limit) {
        var userDataDemirag = localStorage.getItem("userDataDemirag");
        var param = {
            token: userDataDemirag,
            baslamaTarihi,
            bitisTarihi,
            sebep,
            tamGun,
            gunMiktari,
            baslangic,
            limit,
            serviceName: moduleName,
            methodName: "ara"
        }
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
        return result
    },
    musteriSayisi(durum) {
        var userDataDemirag = localStorage.getItem("userDataDemirag");
        var param = {
            token: userDataDemirag,
            durum: durum,
            serviceName: moduleName,
            methodName: "musteriSayisi"
        }
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
        return result
    },
    resmiTatilDuzenle(resmiTatilID, form) {
        var userDataDemirag = localStorage.getItem("userDataDemirag");
        var param = {
            token: userDataDemirag,
            resmiTatilID,
            baslamaTarihi: form.tatilTarihleri[0],
            bitisTarihi: form.tatilTarihleri[1],
            sebep: form.sebep,
            tamGun: form.tamGun,
            gunMiktari: form.gunMiktari,
            serviceName: moduleName,
            methodName: "guncelle"
        }
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
        return result
    },
}

export default tatilService